
<div class="form-check">
    <input class="form-check-input" type="checkbox" [value]="value" [(ngModel)]="data[key]" [id]="key" [checked]="data[key]">
    <label class="form-check-label fw-bolder" [for]="key">
        {{title}}
    </label>
</div>